// extracted by mini-css-extract-plugin
module.exports = {"alert":"CheckoutAlertInline_alert__3nZdQ","iconWrap":"CheckoutAlertInline_iconWrap__1rpLV","icon":"CheckoutAlertInline_icon__1oWZ5","message":"CheckoutAlertInline_message__3fP7u"};